const PERIOD_BOUNDARY_DAY = 15;

export const getAttorneysReportPeriod = (month: number, year: number) => ({
  from: new Date(year, month - 1, PERIOD_BOUNDARY_DAY).toISOString(),
  to: new Date(year, month, PERIOD_BOUNDARY_DAY).toISOString(),
});
